module.exports = __webpack_public_path__ + "static/media/ic_video_off_small.0ccaf85c.svg";